import { IProfile } from 'interfaces/user.interfaces';

export const checkPatientInfo = (profile: IProfile | null): boolean => {
  if (!profile?.customer) {
    return false;
  }

  const { firstName, lastName, dob, gender, email, mobilePhone, landlinePhone, address } =
    profile.customer || {};

  if (
    !firstName ||
    !lastName ||
    !dob ||
    !gender ||
    !email ||
    (!mobilePhone && !landlinePhone) ||
    !address?.streetAddress ||
    !address?.city ||
    !address?.country ||
    !address?.postalCode
  ) {
    return false;
  }

  // GP Surgery temporarily not required
  // if (
  //   (_formUuid === FORM_UUID_WEIGHT_LOSS_CLINIC || _formUuid === FORM_UUID_GENERAL_PRESCREENING) &&
  //   !surgery
  // ) {
  //   return false;
  // }

  return true;
};
